import { PageApiError } from '@api/utils/PageApiError'

export async function handleApiResponse(response: Response) {
    if (!response.ok) {
        const text = await response.text()
        return Promise.reject(PageApiError.fromResponse(response, text))
    }
    return response.json()
}
